import { db } from "./firebaseConfig";
import { doc, updateDoc } from "firebase/firestore";


const actualizarProveedor = async ({
    idDoc,
    nombre,
    correo,
    telefono,
    direccion,
    estado, 
    cuit,
    cfiva,
    razonSocial
}) => {
    const documento = doc(db, "proveedores", idDoc);

    return await updateDoc(documento, {
        nombre:nombre,
        correo:correo,
        telefono:telefono,
        direccion:direccion,
        estado:estado,
        cuit:cuit,
        cfiva:cfiva,
        razonSocial:razonSocial
    });
}

export default actualizarProveedor;